<template>
  <venue-form
    :formKey="editFormKey"
    :action="`/admin/venues/${venueId}`"
    :venueId="venueId"
    method="patch"
    @formValid="(val) => formValid = val"
    :additional-data="{ ...primaryUser }"
    :venue-data="venue"
    @submitSuccess="onEditFormSubmit">
    <template #primaryContact>
      <div>
        <primary-contact-dropdown
          :primary-selected="primarySelectedUser"
          :options="users"
          class="mt-12"
          label="Primary Contact"
          name="primaryUserId"
          :form-key="editFormKey"
          @onSelect="primaryContactChanged"
        />
        <div class="contact-info mt-8">
          <p class="contact-info__txt">
            User needs to have a phone number in order to be able to be set as a primary contact.
          </p>
        </div>
      </div>
    </template>
    <template #buttons>
      <ez-button form-type="submit">Save Changes</ez-button>
    </template>
  </venue-form>
</template>

<script>
import flash from '@/components/ui/FlashMessage';
import VenueForm from '@/views/admin/venues/Form.vue';
import EzButton from '@/components/ui/Button';
import Venue from '@/models/Venue';
import { mapActions } from 'vuex';
import PrimaryContactDropdown from '@/views/common/users/PrimaryContactDropdown';

export default {
  components: {
    VenueForm,
    EzButton,
    PrimaryContactDropdown,
  },
  props: {
    venueId: {
      type: Number,
      required: true,
    },
    groupId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formValid: false,
      editFormKey: 'edit-venue',
      users: [],
      primaryUser: {
        primaryUserId: '',
      },
    };
  },
  computed: {
    venue() {
      return Venue.find(this.venueId) || {};
    },
    primarySelectedId() {
      return this.venue?.primaryUserId;
    },
    primarySelectedUser() {
      return this.users.find(user => user.id === this.primarySelectedId) || {};
    },
  },
  methods: {
    ...mapActions('entities/venues', ['fetchVenue']),
    ...mapActions('entities/users', [
      'adminFetchUsers',
    ]),
    onEditFormSubmit({ data }) {
      Venue.update({ data: data.data });
      flash.success({
        title: `${this.$helpers.remapNaming('venue')} successfully updated!`,
      });
    },
    primaryContactChanged(ev) {
      this.primaryUser.primaryUserId = ev.id;
    },
  },
  async created() {
    const { data: { data } } = await this.adminFetchUsers({ groupId: this.groupId });
    this.users = data;
    await this.fetchVenue(this.venueId);
  },
};
</script>

<style scoped lang="scss">
  .venue-form {
    .button {
      margin-top: 1.5rem;
    }
  }
  .contact-info {
    &__txt {
      @include font-size(12px);
      color: $color-gray-6C;
      margin: 0;
      line-height: px-to-rem(18px);
    }
  }
</style>
